import { IContext } from 'unleash-proxy-client'

export type UnleashContextProperties = {
  companyUuid?: string
  leadUuid?: string
}

export interface UnleashContext extends IContext {
  environment: string
  properties: UnleashContextProperties
}

export function isUnleashContext(value: IContext): value is UnleashContext {
  return (
    value.appName === 'string' &&
    typeof value.environment === 'string' &&
    (!value.userId || typeof value.userId === 'string') &&
    (!value.sessionId || typeof value.sessionId === 'string') &&
    (!value.remoteAddress || typeof value.remoteAddress === 'string') &&
    value.properties !== undefined &&
    (!value.properties.companyUuid || typeof value.properties.companyUuid === 'string') &&
    (!value.properties.leadUuid || typeof value.properties.leadUuid === 'string')
  )
}
